export const UPDATE_COORDINATES = 'UPDATE_COORDINATES';
export const ADD_MAP = 'ADD_MAP';
export const UPDATE_TOPOLOGY = 'UPDATE_TOPOLOGY';
export const UPDATE_LEGEND = 'UPDATE_LEGEND';
export const UPDATE_LEGEND_LEFT = 'UPDATE_LEGEND_LEFT';
export const UPDATE_POPUP = 'UPDATE_POPUP';
export const UPDATE_OVERLAYS = 'UPDATE_OVERLAYS';

export const onAddMap = (value) => ({
	type: ADD_MAP,
	value
});

export const onUpdateCoordinates = (value) => ({
	type: UPDATE_COORDINATES,
	value
});

export const onUpdateTopology = (value) => ({
	type: UPDATE_TOPOLOGY,
	value
});

export const onUpdateLegend = (value) => ({
	type: UPDATE_LEGEND,
	value
});

export const onUpdateLegendLeft = (value) => ({
	type: UPDATE_LEGEND_LEFT,
	value
});

export const onUpdatePopup = (value) => ({
	type: UPDATE_POPUP,
	value
});

export const onUpdateOverlays = (value) => ({
	type: UPDATE_OVERLAYS,
	value
});
